/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecapitoDto } from '../../models/recapito-dto';

export interface ApiRecapitoRecapitoCorpoListGet$Params {}

export function apiRecapitoRecapitoCorpoListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiRecapitoRecapitoCorpoListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecapitoDto>>> {
    const rb = new RequestBuilder(rootUrl, apiRecapitoRecapitoCorpoListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<RecapitoDto>>;
        }),
    );
}

apiRecapitoRecapitoCorpoListGet.PATH = '/api/recapito/recapito-corpo-list';
